import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    adminAuthenticated: false,
    adminType: null,
  },
  reducers: {
    setAdminAuthenticated: (state, action) => {
      state.adminAuthenticated = action.payload.authenticated;
      state.adminType = action.payload.type;
    },
  },
});

export const {
  setUser,
  setLogout,
  setPremiumAccess,
  setVavAccess,
  setAdminAuthenticated,
} = userSlice.actions;

export const selectPremiumAccess = (state) => state.user.hasPremiumAccess;
export const selectUser = (state) => state.user.user;
export const selectAdminAuthenticated = (state) =>
  state.user.adminAuthenticated;
export const selectAdminType = (state) => state.user.adminType;

export default userSlice.reducer;
